<div class="contact-section d-grid gap-3">
  <div class="row mt-0">
    <div
      class="col-lg-8"
      [class.text-center]="!isEssent()"
      [class.offset-lg-2]="!isEssent()"
    >
      <h2 class="contact-section__title" *scText="title()"></h2>
      @if (showIntroduction() && introduction(); as introduction) {
        <div class="contact-section__introduction" *scText="introduction"></div>
      }
    </div>
  </div>

  <ul class="row list-unstyled -mt-3 mb-0 gx-4 gy-3">
    @for (contactItem of contactItems(); track uid() + $index) {
      <li
        class="col-12 mb-0"
        [ngClass]="{
          'col-md': isEssent(),
          'col-md-6 col-lg': !isEssent(),
        }"
      >
        <wl-contact-item
          [uid]="uid() + '-' + $index"
          [icon]="contactItem.icon"
          [title]="contactItem.title"
          [description]="contactItem.description"
          [alternativeButton]="contactItem.alternativeButton"
          [chatButton]="contactItem.chatButton"
        />
      </li>
    }
  </ul>
</div>
